import { Button, Form } from 'antd';
import classNames from 'classnames';

import { Icon } from '@/shared/ui/Icon';
import { TextInput } from '@/shared/ui/TextInput/TextInput';

import type { ConnectorField } from '@/entities/connector';
import { buildConnectorFieldRules } from '@/entities/connector/lib/connectorFieldRules';

import { ASSET_URI_FIELDS } from '@/features/connectors/model/useAssetURIFieldsReset';
import { AssetUriTooltip } from '@/features/connectors/ui/AssetUriTooltip';

import styles from './ConnectorAssetURIFields.module.css';

const DISPLAY_LABELS: Record<string, string> = {
  enterprise: 'Enterprise',
  site: 'Site',
  area: 'Area',
  process: 'Process',
  unit: 'Unit',
  component: 'Component',
  dataName: 'Name',
};

const buildFormItemProps = (field: ConnectorField) => {
  return {
    name: ['dataInfo', field.label],
    label: DISPLAY_LABELS[field.label] ?? field.label,
    rules: buildConnectorFieldRules(field),
  };
};

type ConnectorAssetURIFieldsProps = {
  step: number;
  isReset: boolean;
  onResetFields: () => void;
};

export const ConnectorAssetURIFields = ({ step, isReset, onResetFields }: ConnectorAssetURIFieldsProps) => {
  return (
    <div className={classNames(styles.wrapper, { [styles.hidden]: step === 2 })}>
      <div className={styles.dataInfoFields}>
        <h2 className={styles.title}>
          기본 정보
          <AssetUriTooltip iconClassName={styles.tooltipIcon} />
        </h2>
        <Button type="text" onClick={onResetFields} disabled={!isReset}>
          <Icon
            name="reset"
            size={16}
            className={classNames(styles.resetIcon, { [styles.resetIconActive]: isReset })}
          />
          <span className={classNames(styles.buttonText, { [styles.buttonTextActive]: isReset })}>초기화</span>
        </Button>
      </div>
      <div className={styles.assetURIFields}>
        <div className={styles.assetURIFieldsContent}>
          {ASSET_URI_FIELDS.dataInfo.map((field) => (
            <Form.Item className={styles.configFieldItem} key={field.label} {...buildFormItemProps(field)}>
              <TextInput type="text" placeholder={field.placeholder} />
            </Form.Item>
          ))}
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.dataNameFields}>
        <div className={styles.dataNameFieldsContent}>
          {ASSET_URI_FIELDS.dataName.map((field) => (
            <Form.Item className={styles.configFieldItem} key={field.label} {...buildFormItemProps(field)}>
              <TextInput type="text" placeholder={field.placeholder} />
            </Form.Item>
          ))}
        </div>
      </div>
    </div>
  );
};
